import { Card, Collapse, Group, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconDiscount } from '@tabler/icons-react';
import { useState } from 'react';
import templateWizardFormFields from '../../../constants/templateWizardFormFields';
import TemplateFields from './templateFields';

const DiscountBadgeForm = ({ disabled, handleChangeStyles, productBlockStyles, showPosition, handleChangeColors }) => {
  const [open, setOpen] = useState(false);

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <UnstyledButton onClick={() => setOpen(!open)} w="100%">
          <Group justify="space-between">
            <Group gap="xs">
              <IconDiscount size={18} color="var(--mantine-color-dimmed)" />
              <Text fw={500}>Discount Badge</Text>
            </Group>
            {open ? <IconChevronUp size={18} /> : <IconChevronDown size={18} />}
          </Group>
        </UnstyledButton>
      </Card.Section>
      <Collapse expanded={open}>
        <Card.Section inheritPadding py="sm">
          <TemplateFields
            disabled={disabled}
            handleChangeStyles={handleChangeStyles}
            productBlockStyles={productBlockStyles}
            handleChangeColors={handleChangeColors}
            fieldConfigs={templateWizardFormFields.discountBadgFields}
          />
        </Card.Section>
      </Collapse>
    </Card>
  );
};

export default DiscountBadgeForm;
